import { Component } from '@angular/core';

@Component({
  selector: 'd-card',
  standalone: true,
  imports: [],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {}